export const PaperIcon = ({ size = 80, color = "#2C3E50" }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 99 98" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path 
        d="M10.624,56.495C10.624,56.495 4.541,88.066 31.867,94.623L38.948,95.713C38.948,95.713 61.092,96.999 69.451,86.998C77.811,76.996 96.793,59.103 96.142,52.137C96.031,50.958 94.835,47.603 94.179,46.969C89.361,42.312 86.329,45.13 80.345,50.503C74.545,55.711 74.354,55.95 74.354,55.95C74.354,55.95 72.362,57.551 68.907,55.95C66.283,54.636 66.728,51.592 66.728,51.592C66.728,51.592 80.803,8.647 66.728,6.927C58.64,5.939 56.763,15.713 53.655,42.877C53.655,42.877 57.513,0.828 44.94,2.025C32.367,3.222 37.859,42.333 37.859,42.333C37.859,42.333 33.804,3.516 21.518,7.472C9.233,11.428 23.697,46.145 23.697,46.145C23.697,46.145 14.065,20.524 6.811,22.179C-0.442,23.833 0.253,35.979 10.624,56.495" 
        fill="white" 
        stroke={color} 
        strokeWidth="4" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M59.647,61.397C59.647,61.397 43.602,59.567 40.038,79.372" 
        fill="none" 
        stroke={color} 
        strokeWidth="4" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
};
